// extracted by css-extract-rspack-plugin
export default {"content":"content-B_4w1f","title":"title-kkDfgN text-headline-sm","steps":"steps-iolDOi","stepNumber":"stepNumber-lPaSMy","stepText":"stepText-oltsBs text-body-label"};